import React from 'react'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const Container = styled(motion.div)`
  &.full {
    width: 100%;
  }
`

export default function FadeDiv({
  initial,
  final,
  orientation,
  delay = 0,
  children,
  full = false,
}) {
  if (orientation === 'vertical') {
    return (
      <Container
        initial="hidden"
        animate="visible"
        exit="exit"
        className={`${full ? 'full' : ''}`}
        variants={{
          hidden: {
            opacity: 0,
            y: initial,
          },
          visible: {
            opacity: 1,
            y: final,
            transition: {
              delay,
            },
          },
        }}
      >
        {children}
      </Container>
    )
  }

  return (
    <Container
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`${full ? 'full' : ''}`}
      variants={{
        hidden: {
          opacity: 0,
          x: initial,
        },
        visible: {
          scale: 1,
          opacity: 1,
          x: final,
          transition: {
            delay,
          },
        },
      }}
    >
      {children}
    </Container>
  )
}
